import React from 'react';

import { RouletteColorResult } from 'types/tables';
import { IconNames } from 'components/atoms';
import {
  Result,
  ResultLabel,
  ResultValue,
  ResultValueBG,
  ResultsWrap,
  Wrapper,
  ResultItem,
} from './styles';

export interface IProps {
  value?: {
    color: RouletteColorResult;
    number: number;
  };
}

export const RouletteResult = ({ value }: IProps) => (
  <Wrapper value={value}>
    {value?.number !== null && value?.number !== undefined ? (
      <ResultValueBG name={IconNames.BallBackground} />
    ) : null}
    <ResultsWrap>
      {value?.number !== null && value?.number !== undefined ? (
        <Result>
          <ResultValue value={value.color}>
            <ResultItem>{value.number}</ResultItem>
          </ResultValue>
          <ResultLabel>
            {value.number} {value.color}
          </ResultLabel>
        </Result>
      ) : (
        <Result>
          <ResultValue value={RouletteColorResult.UNDEFINED}>
            <ResultItem />
          </ResultValue>
        </Result>
      )}
    </ResultsWrap>
  </Wrapper>
);
